import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from "react-intl";
import { Link } from 'react-router-dom';
import * as paths from '@app/constants/paths';
// nodejs library that concatenates classes
import classNames from "classnames";
// components
import GridContainer from '@app/components/Grid/GridContainer';
import GridItem from '@app/components/Grid/GridItem';
import Card from '@app/components/Card/Card';
import CardHeader from '@app/components/Card/CardHeader';
import CardBody from '@app/components/Card/CardBody';
import CardFooter from '@app/components/Card/CardFooter';
import CustomInput from '@app/components/CustomInput/CustomInput';
import Button from '@app/components/CustomButtons/Button';
import CustomAccordion from "@app/components/Accordion/CustomAccordion";
// material-ui-core
import InputAdornment from "@material-ui/core/InputAdornment";
// icons
import SaveIcon from '@material-ui/icons/Save';
import CheckIcon from '@material-ui/icons/Check';
import ClearIcon from '@material-ui/icons/Clear';
// FontIcons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//styles
import withStyles from '@material-ui/core/styles/withStyles';
import surveyPageStyle from '@app/assets/jss/material-kit-pro-react/views/surveyPageStyle';

const ProjectedOutcomesView = (props) => {
    const classes = props.classes;
    // Validation messages
    // Projected Outcomes
    const marketExpansionError = props.validationErrors.marketExpansion.show;
    const marketExpansionHelperText = props.validationErrors.marketExpansion.show ? props.validationErrors.marketExpansion.errorMessage : '';
    const turnoverYear1HelperText = props.validationErrors.turnoverYear1.show ? props.validationErrors.turnoverYear1.errorMessage : '';
    const turnoverYear2HelperText = props.validationErrors.turnoverYear2.show ? props.validationErrors.turnoverYear2.errorMessage : '';
    const turnoverYear3HelperText = props.validationErrors.turnoverYear3.show ? props.validationErrors.turnoverYear3.errorMessage : '';
    const fullTimeStaffYear1HelperText = props.validationErrors.fullTimeStaffYear1.show ? props.validationErrors.fullTimeStaffYear1.errorMessage : '';
    const fullTimeStaffYear2HelperText = props.validationErrors.fullTimeStaffYear2.show ? props.validationErrors.fullTimeStaffYear2.errorMessage : '';
    const fullTimeStaffYear3HelperText = props.validationErrors.fullTimeStaffYear3.show ? props.validationErrors.fullTimeStaffYear3.errorMessage : '';
    const partTimeStaffYear1HelperText = props.validationErrors.partTimeStaffYear1.show ? props.validationErrors.partTimeStaffYear1.errorMessage : '';
    const partTimeStaffYear2HelperText = props.validationErrors.partTimeStaffYear2.show ? props.validationErrors.partTimeStaffYear2.errorMessage : '';
    const partTimeStaffYear3HelperText = props.validationErrors.partTimeStaffYear3.show ? props.validationErrors.partTimeStaffYear3.errorMessage : '';

    const now = new Date();
    return (
        <GridContainer justify='center'>
            <GridItem xs={12}>
                <form name="trading-online-voucher-scheme-2020">    
                    <Card className={classes.cardSignUp}>
                        <CardHeader color='danger' className={classes.cardHeaderSignUp}>
                            <h3 className={classNames(classes.cardTitle, classes.title)} id="projectElements">
                                PROJECTED OUTCOMES
                            </h3>
                        </CardHeader>
                        <CardBody className={classes.cardBodySignUp}>
                            <h4 className={classes.title} id="marketExpansion">
                                <FontAwesomeIcon icon={['fas', 'key']} className={classes.iconCheckboxIcon + " " + classes.keySection} />
                                Market Expansion Potential&nbsp;
                                {props.validationErrors.marketExpansion.check === null ? ' ' : (props.validationErrors.marketExpansion.check ? <CheckIcon htmlColor="green" fontSize="large"/> : <ClearIcon htmlColor="red" fontSize="large"/>)}
                            </h4>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={12} md={8}>
                                    <CustomAccordion
                                        active={1}
                                        activeColor="danger"
                                        collapses={[
                                            {
                                                title: "Help",
                                                content:
                                                <span>
                                                    <p>We speculate that this may be the most crucial section of the application.</p>
                                                    <p>You need to state what impact the trading online project will have on your business in terms of employment, revenue, and export potential.</p>
                                                    <p>Some questions you can ask yourself to help fill this section are:</p>
                                                    <ul>
                                                        <li>Based on your target market and competitor analysis, how will this project help you grow your revenue? </li>
                                                        <li>Is there an export potential?</li>
                                                        <li>Can you gain back lost market share to existing online traders?</li>
                                                        <li>How could the project aid the business during the COVID-19 Pandemic?</li>
                                                        <li>Is there potential to grow internationally (Northern Ireland / Britain / EU / USA).</li>
                                                    </ul>
                                                    <p>Some example reasons that you can give are:</p>
                                                    <ul>
                                                        <li>A retail shop is now closed lost 90% of sales - moving all online.</li>
                                                        <li>Generating about 30% of my normal revenue now online.</li>
                                                        <li>Plan to keep 2 people working as a result of this online investment.</li>
                                                        <li>Trying out online for the first time.</li>
                                                    </ul>
                                                    <p>Your LEO will be happy to see any business looking to try online for the first time. If nothing else, the Trading Online Voucher Scheme is an opportunity to initiate contact with your LEO, whose sole purpose is to help local businesses like yours succeed. Whilst the Trading Online Voucher Scheme is a competitive process, it is one where the LEO is eager and willing, where criteria is met, and some effort is shown, to reward <b>every</b> participant.</p>
                                                </span>
                                            }
                                        ]}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={12} md={8}>
                                    <CustomInput
                                        id='marketExpansionInput'
                                        helperText={marketExpansionHelperText}
                                        error={marketExpansionError}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        inputProps={{
                                            multiline: true,
                                            rows: 6,
                                            name: 'marketExpansion',
                                            value: props.marketExpansion,
                                            onChange: props.handleMarketExpansion,
                                            autoComplete: 'off',
                                            startAdornment: (
                                                <InputAdornment position='start'>
                                                    <FontAwesomeIcon icon={['fas', 'expand-alt']} className={classes.inputIconsColor} />
                                                </InputAdornment>
                                            ),
                                            type: 'number'
                                        }}
                                    />
                                </GridItem>
                            </GridContainer>
                            <h4 className={classes.title} id="financialInfo">
                                Financial Information&nbsp;
                                {(props.validationErrors.turnoverYear1.check && props.validationErrors.turnoverYear2.check && props.validationErrors.turnoverYear3.check) === null ? ' ' : (props.validationErrors.turnoverYear1.check && props.validationErrors.turnoverYear2.check && props.validationErrors.turnoverYear3.check) ? <CheckIcon htmlColor="green" fontSize="large"/> : <ClearIcon htmlColor="red" fontSize="large"/>}
                            </h4>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={12} md={8}>
                                    <CustomAccordion
                                        active={1}
                                        activeColor="danger"
                                        collapses={[
                                            {
                                                title: "Help",
                                                content:
                                                <span>
                                                    <p>Here comes the tricky part. But the good the news is that all you need to do is guess.</p>
                                                    <p>You need to state how things are right now, and guess what you expect in 12 months and in 24 months.</p>
                                                    <p>It's best to be conservative, but be a little optimistic. You will not be expected to double anything in one year, a rise of 10% to 30% in anything is great.</p>
                                                    <p><a href="https://app.box.com/v/OnlineVoucher" target="_blank" rel="noopener">LEO stats</a> indicate an average <b>21% increase in sales</b>.</p>
                                                </span>
                                            }
                                        ]}
                                    />
                                </GridItem>
                            </GridContainer>
                            <h5 className={classes.title} id="turnover">
                                Turnover
                            </h5>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={6} md={4}>
                                    <CustomInput
                                        id='turnoverYear1'
                                        labelText={now.getFullYear()}
                                        helperText={turnoverYear1HelperText}
                                        error={props.validationErrors.turnoverYear1.show}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        inputProps={{
                                            placeholder: '100,000',
                                            name: 'turnoverYearOne',
                                            value: props.turnoverYear1,
                                            onChange: props.handleTurnoverYear1,
                                            autoComplete: 'off',
                                            startAdornment: (
                                                <InputAdornment position='start'>
                                                    <FontAwesomeIcon icon={['fas', 'euro-sign']} className={classes.inputIconsColor} />
                                                </InputAdornment>
                                            ),
                                            type: 'number'
                                        }}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={6} md={4}>
                                    <CustomInput
                                        id='turnoverYear2'
                                        labelText={now.getFullYear()+1}
                                        helperText={turnoverYear2HelperText}
                                        error={props.validationErrors.turnoverYear2.show}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        inputProps={{
                                            placeholder: '115,000',
                                            name: 'turnoverYearTwo',
                                            value: props.turnoverYear2,
                                            onChange: props.handleTurnoverYear2,
                                            autoComplete: 'off',
                                            startAdornment: (
                                                <InputAdornment position='start'>
                                                    <FontAwesomeIcon icon={['fas', 'euro-sign']} className={classes.inputIconsColor} />
                                                </InputAdornment>
                                            ),
                                            type: 'number'
                                        }}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={6} md={4}>
                                    <CustomInput
                                        id='turnoverYear3'
                                        labelText={now.getFullYear()+2}
                                        helperText={turnoverYear3HelperText}
                                        error={props.validationErrors.turnoverYear3.show}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        inputProps={{
                                            placeholder: '130,000',
                                            name: 'turnoverYearThree',
                                            value: props.turnoverYear3,
                                            onChange: props.handleTurnoverYear3,
                                            autoComplete: 'off',
                                            startAdornment: (
                                                <InputAdornment position='start'>
                                                    <FontAwesomeIcon icon={['fas', 'euro-sign']} className={classes.inputIconsColor} />
                                                </InputAdornment>
                                            ),
                                            type: 'number'
                                        }}
                                    />
                                </GridItem>
                            </GridContainer>
                            <h4 className={classes.title} id="staffNumbers">
                                Staff Numbers&nbsp;
                                {(props.validationErrors.fullTimeStaffYear1.check && props.validationErrors.fullTimeStaffYear2.check && props.validationErrors.fullTimeStaffYear3.check && props.validationErrors.partTimeStaffYear1.check && props.validationErrors.partTimeStaffYear2.check && props.validationErrors.partTimeStaffYear3.check) === null ? ' ' : props.validationErrors.fullTimeStaffYear1.check && props.validationErrors.fullTimeStaffYear2.check && props.validationErrors.fullTimeStaffYear3.check && props.validationErrors.partTimeStaffYear1.check && props.validationErrors.partTimeStaffYear2.check && props.validationErrors.partTimeStaffYear3.check ? <CheckIcon htmlColor="green" fontSize="large"/> : <ClearIcon htmlColor="red" fontSize="large"/>}
                            </h4>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={12} md={8}>
                                    <CustomAccordion
                                        active={1}
                                        activeColor="danger"
                                        collapses={[
                                            {
                                                title: "Help",
                                                content:
                                                <span>
                                                    <p>No need for exaggeration here. Some application forms might ask for full-time staff only, while others might ask for a break-down of full-time and part-time.</p>
                                                    <p>An employee working about 40 hours a week will be considered a full-time employee. Two part-time employees, each working about 20 hours a week might be considered as being equivalent to 1 full-time employee.</p>
                                                    <p>If you currently employ more than 10 full-time employees, you are ineligible to apply for this voucher, but your LEO has <a href="https://www.localenterprise.ie/Discover-Business-Supports/Financial-Supports/" target="_blank" rel="noopener">other supports</a> for you.</p>
                                                    <p>It's best to be conservative, but be a little optimistic. You will not be expected to double anything in one year, a rise of 10% to 30% in anything is great.</p>
                                                    <p><a href="https://app.box.com/v/OnlineVoucher" target="_blank" rel="noopener">LEO stats</a> indicate an average an average of <b>1.4 jobs created</b> per business.</p>
                                                </span>
                                            }
                                        ]}
                                    />
                                </GridItem>
                            </GridContainer>
                            <h5 className={classes.title} id="fullTimeStaff">
                                Full-Time Staff
                            </h5>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={6} md={4}>
                                    <CustomInput
                                        id='fullTimeStaffYear1'
                                        labelText={now.getFullYear()}
                                        helperText={fullTimeStaffYear1HelperText}
                                        error={props.validationErrors.fullTimeStaffYear1.show}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        inputProps={{
                                            placeholder: '1',
                                            name: 'fullTimeStaffYearOne',
                                            value: props.fullTimeStaffYear1,
                                            onChange: props.handleFullTimeStaffYear1,
                                            autoComplete: 'off',
                                            startAdornment: (
                                                <InputAdornment position='start'>
                                                    <FontAwesomeIcon icon={['fas', 'user']} className={classes.inputIconsColor} />
                                                </InputAdornment>
                                            ),
                                            type: 'number'
                                        }}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={6} md={4}>
                                    <CustomInput
                                        id='fullTimeStaffYear2'
                                        labelText={now.getFullYear()+1}
                                        helperText={fullTimeStaffYear2HelperText}
                                        error={props.validationErrors.fullTimeStaffYear2.show}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        inputProps={{
                                            placeholder: '2',
                                            name: 'fullTimeStaffYearTwo',
                                            value: props.fullTimeStaffYear2,
                                            onChange: props.handleFullTimeStaffYear2,
                                            autoComplete: 'off',
                                            startAdornment: (
                                                <InputAdornment position='start'>
                                                    <FontAwesomeIcon icon={['fas', 'user']} className={classes.inputIconsColor} />
                                                </InputAdornment>
                                            ),
                                            type: 'number'
                                        }}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={6} md={4}>
                                    <CustomInput
                                        id='fullTimeStaffYear3'
                                        labelText={now.getFullYear()+2}
                                        helperText={fullTimeStaffYear3HelperText}
                                        error={props.validationErrors.fullTimeStaffYear3.show}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        inputProps={{
                                            placeholder: '3',
                                            name: 'fullTimeStaffYearThree',
                                            value: props.fullTimeStaffYear3,
                                            onChange: props.handleFullTimeStaffYear3,
                                            autoComplete: 'off',
                                            startAdornment: (
                                                <InputAdornment position='start'>
                                                    <FontAwesomeIcon icon={['fas', 'user']} className={classes.inputIconsColor} />
                                                </InputAdornment>
                                            ),
                                            type: 'number'
                                        }}
                                    />
                                </GridItem>
                            </GridContainer>
                            <h5 className={classes.title} id="partTimeStaff">
                                Part-Time Staff
                            </h5>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={6} md={4}>
                                    <CustomInput
                                        id='partTimeStaffYear1'
                                        labelText={now.getFullYear()}
                                        helperText={partTimeStaffYear1HelperText}
                                        error={props.validationErrors.partTimeStaffYear1.show}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        inputProps={{
                                            placeholder: '1',
                                            name: 'partTimeStaffYearOne',
                                            value: props.partTimeStaffYear1,
                                            onChange: props.handlePartTimeStaffYear1,
                                            autoComplete: 'off',
                                            startAdornment: (
                                                <InputAdornment position='start'>
                                                    <FontAwesomeIcon icon={['far', 'user']} className={classes.inputIconsColor} />
                                                </InputAdornment>
                                            ),
                                            type: 'number'
                                        }}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={6} md={4}>
                                    <CustomInput
                                        id='partTimeStaffYear2'
                                        labelText={now.getFullYear()+1}
                                        helperText={partTimeStaffYear2HelperText}
                                        error={props.validationErrors.partTimeStaffYear2.show}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        inputProps={{
                                            placeholder: '2',
                                            name: 'partTimeStaffYearTwo',
                                            value: props.partTimeStaffYear2,
                                            onChange: props.handlePartTimeStaffYear2,
                                            autoComplete: 'off',
                                            startAdornment: (
                                                <InputAdornment position='start'>
                                                    <FontAwesomeIcon icon={['far', 'user']} className={classes.inputIconsColor} />
                                                </InputAdornment>
                                            ),
                                            type: 'number'
                                        }}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={6} md={4}>
                                    <CustomInput
                                        id='partTimeStaffYear3'
                                        labelText={now.getFullYear()+2}
                                        helperText={partTimeStaffYear3HelperText}
                                        error={props.validationErrors.partTimeStaffYear3.show}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        inputProps={{
                                            placeholder: '3',
                                            name: 'partTimeStaffYearThree',
                                            value: props.partTimeStaffYear3,
                                            onChange: props.handlePartTimeStaffYear3,
                                            autoComplete: 'off',
                                            startAdornment: (
                                                <InputAdornment position='start'>
                                                    <FontAwesomeIcon icon={['far', 'user']} className={classes.inputIconsColor} />
                                                </InputAdornment>
                                            ),
                                            type: 'number'
                                        }}
                                    />
                                </GridItem>
                            </GridContainer>
                        </CardBody>
                        <CardFooter className={classes.cardFooterSignUp}>
                            <div className={classes.cardBodySignUpButtons}>
                                <Button color="gray" component={ Link } to={paths.HELPER_T_O_V_S}>
                                    Main Menu
                                </Button>
                                <Button
                                    color="primary"
                                    size="sm"
                                    startIcon={<SaveIcon />}
                                    onClick={props.generateDoc}
                                >
                                    Download
                                </Button>
                            </div>
                        </CardFooter>
                        <CardFooter className={classes.cardFooterSignUp}>
                            <div className={classes.cardBodySignUpButtons}>
                                <Button color='primary' component={ Link } to={paths.HELPER_T_O_V_S_INVEST}>
                                    &lt; Business Investment 
                                </Button>
                                <Button color='primary' component={ Link } to={paths.HELPER_T_O_V_S_ELEMENTS}>
                                    Project Elements &gt;
                                </Button>
                            </div>
                        </CardFooter>
                    </Card>
                </form>
            </GridItem>
        </GridContainer>
    );
}

ProjectedOutcomesView.propTypes = {
    locale: PropTypes.string.isRequired,
    isLoading: PropTypes.bool.isRequired,
    // Projected Outcomes
    handleMarketExpansion: PropTypes.func.isRequired,
    handleTurnoverYear1: PropTypes.func.isRequired,
    handleTurnoverYear2: PropTypes.func.isRequired,
    handleTurnoverYear3: PropTypes.func.isRequired,
    handleFullTimeStaffYear1: PropTypes.func.isRequired,
    handleFullTimeStaffYear2: PropTypes.func.isRequired,
    handleFullTimeStaffYear3: PropTypes.func.isRequired,
    handlePartTimeStaffYear1: PropTypes.func.isRequired,
    handlePartTimeStaffYear2: PropTypes.func.isRequired,
    handlePartTimeStaffYear3: PropTypes.func.isRequired,
    validationErrors: PropTypes.object.isRequired,
    generateDoc: PropTypes.func.isRequired
};

export default injectIntl(withStyles(surveyPageStyle)(ProjectedOutcomesView));